import React from 'react';

const Description = ({items}) => {
  return (
    <>
      <div className='desc__report__box__report'>
        <div className="desc__report__desc iransans-b">
          شرح گزارش
        </div>
        <div className="desc__report__report iransans-b">
          <p>{items.reportDescription}</p>
        </div>
      </div>
      <div className='desc__report__box'>
        <div className="desc__report__desc iransans-b">
          شرح نیاز
        </div>
        <div className="desc__report__container iransans-b">
          <p>{items.needsDescription}</p>
        </div>
      </div>
      <div className="desc__report__bottom">
        <div className="desc__report__end iransans-b">
          <span>مهر</span>
        </div>
        <div className="desc__report__end iransans-b">
          <span>امضا</span>
        </div>
      </div>
    </>
  );
};

export default Description;